import clsx from 'clsx';
import { FC } from 'react';

import { WithClassName } from '../../../types/react';
import { Card32V4Icon } from '../../icons/Card32V4Icon';
import { EnterV4Icon } from '../../icons/EnterV4Icon';
import { LocationV4Icon } from '../../icons/LocationV4Icon';
import { SwapHorizontalV4Icon } from '../../icons/SwapHorizontalV4Icon';
import { WalletV4Icon } from '../../icons/WalletV4Icon';
import { Container } from '../common/Container';
import { Flex } from '../common/Flex';
import { Text } from '../common/Text';

import { PayoutsDemoForm } from './components/PayoutsDemoForm';
import styles from './PayoutsBlock.module.scss';

type PayoutsBlockProps = WithClassName & {};

const PAYOUT_OPTIONS = [
  {
    icon: <SwapHorizontalV4Icon />,
    title: 'Bank transfer',
  },
  {
    icon: <Card32V4Icon />,
    title: 'Cards',
  },
  {
    icon: <WalletV4Icon />,
    title: 'Wallets',
  },
  {
    icon: <EnterV4Icon />,
    title: 'Instant payments',
  },
  {
    icon: <LocationV4Icon />,
    title: 'Local rails',
  },
];

export const PayoutsBlock: FC<PayoutsBlockProps> = (props) => {
  const { className } = props;

  return (
    <Container className={clsx(styles.root, className)}>
      <div className={styles.grid}>
        <Flex className={styles.info} direction="column">
          <Flex direction="column" gap={4}>
            <Text type="h2">
              Fast, predictable settlements
              <br />— and flexible payouts
            </Text>

            <Text type="regular16" color="white50">
              Manage settlement cycles, balances,
              <br />
              and outgoing payments from one place
            </Text>
          </Flex>

          <Flex className={styles.payoutOptions} direction="column" gap={6}>
            {PAYOUT_OPTIONS.map(({ icon, title }, index) => (
              <Flex key={index} gap={6} alignItems="center">
                {icon}

                <Text type="medium18" color="white">
                  {title}
                </Text>
              </Flex>
            ))}
          </Flex>

          <Text type="regular16" color="white50">
            Send payouts to customers, partners, and workforce
          </Text>
        </Flex>

        <PayoutsDemoForm className={styles.form} />
      </div>
    </Container>
  );
};
